module.exports = new __parcel__URL__("repeat.14c8ae60.svg").toString();